import { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import StyledOption from './styledTextInput'
import RadioGroup from 'components/radio-group'
import Radio from 'components/radio'

class OptionGroup extends Component {

  render() {
    const {
      title,
      handleSelect,
      options,
      dataTestId,
      disabled
    } = this.props
    return (
      <StyledOption>
      <div className='select-origem-row'>
      <Row>
        <label className='select-origem-label'>{title}</label>
      </Row>
        <Row>

          <Col>
            <div className='select-origem'>
              <RadioGroup
                directionItems='row'
                label="Origem"
                name={`Options${options.id}`}
              >
                {!options.optionOne.hideOption ? (<Radio
                  checked={options.optionOne.isChecked}
                  text={options.optionOne.name}
                  value={options.optionOne.value}
                  data-testid={`${dataTestId}-first`}
                  onChange={event => handleSelect({ ...event, currentTarget: event.target })}
                  disabled={disabled}
                />): <div></div>}
                {!options.optionTwo.hideOption ? (<Radio
                  checked={options.optionTwo.isChecked}
                  text={options.optionTwo.name}
                  value={options.optionTwo.value}
                  data-testid={`${dataTestId}-second`}
                  onChange={event => handleSelect({ ...event, currentTarget: event.target })}
                  disabled={disabled}
                />): <div></div>}
                {options.optionThree && !options.optionThree.hideOption ? (<Radio
                  checked={options.optionThree.isChecked}
                  text={options.optionThree.name}
                  value={options.optionThree.value}
                  data-testid={`${dataTestId}-third`}
                  onChange={event => handleSelect({ ...event, currentTarget: event.target })}
                  disabled={disabled}
                />) : null}
              </RadioGroup>
            </div>
          </Col>
        </Row>
      </div>
      </StyledOption>
    )
  }
}

OptionGroup.propTypes = {
  title: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool
}

export default OptionGroup
